import { serviceBase } from "../../service";

export default {
  ...serviceBase,
  preList: function(params) {
    const projectId = extractProjectIdFromUrl() || "-";

    const id = params.project_id || projectId;

    delete params.project_id;
    return `projects/${id}`;
  },
  preListOption: {
    getList: true,
    get: true,
    create: true,
    update: true,
    delete: true,
    deleteList: true
  }
};

function extractProjectIdFromUrl() {
  const regex = /projects\/([^/]+)/;
  const match = window.location.href.match(regex);
  return match ? match[1] : null;
}
